export default __webpack_public_path__ + "static/media/esophagus4.a2a95b4d.jpg";